// extracted by mini-css-extract-plugin
export default {"Portfolio":"Portfolio_Portfolio__C3KLB","container":"Portfolio_container__rN7dw"};